import jwt from 'jsonwebtoken';

const DecryptToken = {
  decode: (token: string) => jwt.decode(token),
};

export default DecryptToken;
